import { KeyboardEvent } from "react";
import cn from "classnames";
import { InfoCircle } from "components/UI/Icons";
import { Tooltip, TooltipContent } from "components/UI/Tooltip";
import { LoadingModeCardProps } from "./LoadingModeCard.types";
import s from "./LoadingModeCard.module.scss";

export const LoadingModeCard = ({ title, description, tooltip, selected, onSelect }: LoadingModeCardProps) => {
  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onSelect();
    }
  };

  return (
    <div
      className={cn(s.card, { [s.selected]: selected })}
      onClick={onSelect}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-pressed={selected}
    >
      <span className={cn(s.radio, { [s.radioSelected]: selected })} aria-hidden />

      <span className={s.content}>
        <span className={s.title}>{title}</span>
        <span className={s.description}>{description}</span>
      </span>

      <Tooltip
        triggerElement={
          <button type="button" className={s.info} aria-label="Info" onClick={(event) => event.stopPropagation()}>
            <InfoCircle width={16} height={16} />
          </button>
        }
        offsetY={8}
        placement="top"
        enabledOnMobile
      >
        <TooltipContent className={s.tooltipContent}>{tooltip}</TooltipContent>
      </Tooltip>
    </div>
  );
};
